import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Profile } from '../models/profile.model';

import { ProfileService } from '../services/profile.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class SearchResultResolver
  implements Resolve<Observable<Array<Profile>>>
{
  constructor(
    private authService: AuthService,
    private profileService: ProfileService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    let value = route.params['searchValue'];
    let cat = '';
    let subcat = '';
    let user = this.authService.getUser();
    if (route.params['cat']) {
      cat = route.params['cat'];
    }
    if (route.params['subcat']) {
      subcat = route.params['subcat'];
    }

    this.addToRecentSearch(value);
    if (user != null) {
      // API call
      let params = new HttpParams()
        .set('userId', user.userId)
        .set('searchString', value)
        .set('cat', cat)
        .set('subcat', subcat);

      if (user.defaultProfileId != null) {
        params = params.set('profileId', user.defaultProfileId.toString());
      }

      return this.profileService.searchRankedProfiles(params);
    } else {
      const params = new HttpParams()
        .set('userId', '')
        .set('searchString', value)
        .set('cat', cat)
        .set('subcat', subcat);
      // API call
      return this.profileService.searchRankedProfiles(params);
    }
  }

  addToRecentSearch(value: any) {
    let user = this.authService.getUser();
    if (user != null) {
      if (value !== undefined) {
        const user = this.authService.getUser();
        const params = new HttpParams()
          .set('searchString', value)
          .set('userId', user.userId)
          .set('profileId', user.defaultProfileId);
        // API call
        this.profileService.addToSearchHistory(params).subscribe((res) => {
          const respData = res;
          if (respData.success === 0) {
          }
        });
      }
    }
  }
}
